import React, { useEffect, useState } from 'react';
export function Countdown() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 0,
    minutes: 14,
    seconds: 53
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) {
          return {
            ...prev,
            seconds: prev.seconds - 1
          };
        } else if (prev.minutes > 0) {
          return {
            ...prev,
            minutes: prev.minutes - 1,
            seconds: 59
          };
        } else if (prev.hours > 0) {
          return {
            hours: prev.hours - 1,
            minutes: 59,
            seconds: 59
          };
        }
        return prev;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const format = (num: number) => num.toString().padStart(2, '0');
  return <div className="flex items-center justify-center gap-2 md:gap-4 font-heading text-2xl md:text-4xl font-bold" data-id="element-177">
      <div className="bg-petroleum border border-electric/30 rounded-lg p-3 md:p-4 min-w-[70px] md:min-w-[90px] text-center text-white glow-electric gauge-bezel tabular-nums" data-id="element-178">
        {format(timeLeft.hours)}
        <div className="text-xs md:text-sm text-textsecondary font-body font-normal mt-1 uppercase tracking-wider" data-id="element-179">
          hs
        </div>
      </div>
      <div className="text-electric animate-pulse pb-6" data-id="element-180">:</div>
      <div className="bg-petroleum border border-electric/30 rounded-lg p-3 md:p-4 min-w-[70px] md:min-w-[90px] text-center text-white glow-electric gauge-bezel tabular-nums" data-id="element-181">
        {format(timeLeft.minutes)}
        <div className="text-xs md:text-sm text-textsecondary font-body font-normal mt-1 uppercase tracking-wider" data-id="element-182">
          min
        </div>
      </div>
      <div className="text-electric animate-pulse pb-6" data-id="element-183">:</div>
      <div className="bg-petroleum border border-electric/30 rounded-lg p-3 md:p-4 min-w-[70px] md:min-w-[90px] text-center text-white glow-electric gauge-bezel tabular-nums" data-id="element-184">
        {format(timeLeft.seconds)}
        <div className="text-xs md:text-sm text-textsecondary font-body font-normal mt-1 uppercase tracking-wider" data-id="element-185">
          seg
        </div>
      </div>
    </div>;
}